import _ from 'lodash';

class ModalLoaderService {
  constructor($uibModal) {
    this.$uibModal = $uibModal;
    this.modalStack = [];
  }

  show(componentDef, properties, windowClass){
    let modalInstance = this.$uibModal.open({
      template: componentDef.template,
      keyboard: true,
      windowClass: windowClass || '',
      controller: this.getInjecteds(componentDef.controller, properties),
      controllerAs: componentDef.controllerAs,
      resolve: this.getResolvers(properties)
    });
    this.modalStack.push(modalInstance);
  }

  close() {
    let topInstance = this.modalStack.pop();
    if (topInstance) {
      topInstance.close();
    }
  }

  getResolvers(properties){
    let propertyResolvers = _.mapValues(properties, (property) => {
      return function() { return property; };
    });
    return propertyResolvers;
  }

  getInjecteds(controller, properties) {
    let injectedArray = [];
    let propertyKeys = _.keys(properties);
    injectedArray = injectedArray.concat(controller.$inject);
    injectedArray = injectedArray.concat(propertyKeys);
    injectedArray.push(controller);
    return injectedArray;
  }

  closeAll() {
    this.modalStack.forEach((modal) => {
      modal.close();
    });
    this.modalStack = [];
  }
}
ModalLoaderService.$inject = ['$uibModal'];
export
default ModalLoaderService;



// WEBPACK FOOTER //
// ./app/common/modalLoader/modalLoader.service.js